<template>
   <v-card flat>
    <v-card-title>GET - /api/version</v-card-title>
    <hr />
    <v-card-text>
      <v-simple-table class="table">
        <template v-slot:default>
          <tbody>
            <tr>
              <td>HTTP Method :</td>
              <td>GET</td>
            </tr>
            <tr>
              <td>URL :</td>
              <td>
                <a :href="url + restUrl" target="_blank">{{url +restUrl}}</a>
              </td>
            </tr>
            <tr>
              <td>Description :</td>
              <td>This function allows you to get latest version of API.</td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-card-text>

    <v-card-title>Response Class (Status 200):</v-card-title>
    <v-card-text>OK</v-card-text>

    <v-card-title>Response Body</v-card-title>
    <v-card-text>"1.0"</v-card-text>

    <v-card-title>Response code</v-card-title>
    <v-card-text>200</v-card-text>

  </v-card>
</template>

<script>
export default {
  name: "adddressapi",

  data: () => ({
    url: process.env.VUE_APP_BASE_URL,
    restUrl: "version",
    jsonResponse: [
      {
        OrganisationName: "APPNOVATION TECHNOLOGIES LTD",
        DepartmentName: "",
        PoBoxNumber: "",
        SubBuilding: "",
        Building: "READING BRIDGE HOUSE",
        DependentThoroughfare: "",
        Thoroughfare: "READING BRIDGE",
        DoubleDependentLocality: "",
        DependentLocality: "",
        PostTown: "READING",
        Postcode: "RG1 8LS"
      }
    ],
    postcodeLists: [
      {
        text:
          "Postcode value is mandatory. Postcode should be valid otherwise its throws an error Postcode does not exist."
      },
      {
        text:
          "Postcode value can contain single (*) wildcard character.(E.g. RG1*Ls)"
      },
      {
        text:
          "Double wildcard character not allowed in postcode. (E.g. RG1**s , R*L1*s)"
      }
    ],
    otherLists: [
      {
        text:
          "Every filed in output is separated by | and if number of lines are in the output then it is separated by “,”."
      },
      {
        text: "If any field value is empty then output looks like ||."
      },
      {
        text:
          "When “serialised” parameter value is false, then it returns output in below format –"
      }
    ],
    orderNumber: 5
  })
};
</script>